import type { BlockEditorLabels } from '@whinerp/ui';
import type { useT } from '../../app/i18n.js';

/**
 * The block editor's strings, in one place for all three callers.
 *
 * The component takes a required labels object because the library has no
 * message catalogue, and a string written inside it would be English in every
 * workspace. Three callers building the same object three times would be three
 * places for one of them to drift, so it is built once here - the same
 * arrangement `ruleBuilderLabels` has.
 */
export function blockEditorLabels(t: ReturnType<typeof useT>): BlockEditorLabels {
  return {
    palette: t('content.blocks'),
    canvas: t('content.canvas'),
    settings: t('content.settings'),
    addBlock: (type) => t('flow.addStep', { values: { label: type } }),
    blockType: {
      text: t('content.block.text'),
      heading: t('content.block.heading'),
      image: t('content.block.image'),
      button: t('content.block.button'),
      divider: t('content.block.divider'),
      spacer: t('content.block.spacer'),
      columns: t('content.block.columns'),
      quote: t('content.block.quote'),
      video: t('content.block.video'),
      unsubscribe: t('content.block.unsubscribe'),
      'line-items': t('content.block.lineItems'),
    },
    moveUp: t('content.moveUp'),
    moveDown: t('content.moveDown'),
    remove: t('content.remove'),
    text: t('content.words'),
    url: t('content.file'),
    alt: t('content.description'),
    href: t('content.link'),
    align: t('content.align'),
    alignOptions: {
      start: t('content.align.start'),
      center: t('content.align.center'),
      end: t('content.align.end'),
    },
    preview: t('content.preview'),
    previewMode: {
      desktop: t('content.preview.desktop'),
      mobile: t('content.preview.mobile'),
      dark: t('content.preview.dark'),
    },
    missingTokens: t('content.missingTokens'),
    missingTokensHelp: t('content.missingTokensHelp'),
    empty: t('content.empty'),
    problems: t('content.problems'),
    selectBlock: t('content.selectBlock'),
    testSend: t('content.testSend'),
  };
}
